exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h2[data-v-2c310b40]{font-size:2rem;text-transform:uppercase;font-weight:700;margin-bottom:15px;margin-top:10px}form[data-v-2c310b40]{padding-bottom:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c310b40","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/fiches/bsdd/NewFibsdd.vue
// module id = 621
// module chunks = 0